import React from "react";
import "./Banner.css";

import Carousel from "./Carousel.js";
import image1 from "./images/banners/shandon.png";
import image2 from "./images/banners/ucc.png";
import image3 from "./images/banners/mtu.png";
import image4 from "./images/banners/ucc2.png";
import image5 from "./images/banners/aula.png";

export default function BannerNew() {
  return (
    <div className="banner">
      <div className="text-container">
        <h1>IEEE SmartComp 2025</h1>
        <h2>University College Cork & Munster Technological University</h2>
        <h2>Cork, Ireland</h2>
        <h2>16th ~ 19th June</h2>
      </div>
      <Carousel>
        <div>
          <img src={image1} alt="img1" />
        </div>
        <div>
          <img src={image2} alt="img2" />
        </div>
        <div>
          <img src={image3} alt="img3" />
        </div>
        <div>
          <img src={image4} alt="img4" />
        </div>
        <div>
          <img src={image5} alt="img5" />
        </div>
      </Carousel>
    </div>
  );
}
